export const PERMISSION = {
    DASHBOARD_ALL: ['SA1', 'M11', 'MS1', 'SPA1','L1'],
    DASHBOARD_24_HR_DATA: ['SV1', 'CS1'], //TBD
    USER_MGMT_ADD: ['SA1', 'SPA1'],
    USER_MGMT_RESET_PASSWORD: ['SA1', 'M1', 'SPA1'],
    USER_MGMT_HIDE_DETAIL: ['CS3'],
    VENDOR_ALL: ['SA1', 'SA2', 'M2', 'MS2', 'A1', 'SV3', 'SPA1'],
    VENDOR_UPLOAD: ['SA2', 'M2', 'MS2', 'A1', 'SV3', 'CS5', 'SPA1'], //table view and edit CS5
    VENDOR_VIEW: ['CS6'], //table view all diseble
    VENDOR_HIDE_DETAIL: ['CS4'],
    VENDOR_MGMT_RESET_PASSWORD: ['CS2', 'SV2'],
    DRIVER_ALL: ['SA11', 'SA11', 'M11', 'MS11', 'A11', 'SV11', 'SPA11'],
    DRIVER_UPLOAD: ['SA11','SA11', 'M11', 'MS11', 'A11', 'SV11', 'CS11', 'SPA11'], 
    DRIVER_VIEW: ['SA11', 'M11', 'MS11', 'SPA11','SA11'], 
    DRIVER_HIDE_DETAIL: ['CS11'],
    DRIVER_MGMT_RESET_PASSWORD: ['SA11', 'M11', 'SPA11'],
    CUSTOMER_ALL: ['SA1', 'SA3', 'M3', 'MS3', 'SV4', 'SPA1'],
    CUSTOMER_VIEW: ['CS7'],
    BLOG_ALL: ['SA4', 'M4', 'MS4', 'SPA1'],
    PARKING_SPACE_ALL: ['SA5', 'M5', 'MS5', 'SPA1'],
    BOOKING_ALL: ['SA6', 'M6', 'MS6', 'A2', 'SPA1','L1'],
    BOOKING_ALL_ENCRYPT: ['SV5', 'CS8'],
    REVENUE_ALL: ['SA7', 'M7', 'A3', 'SPA1'],
    CITY_ALL: ['SA8', 'M8', 'MS7', 'A4', 'SPA1'],
    OFFERS_ALL: ['SA9', 'M9', 'MS8', 'SPA1'],
    PARKING_TYPE_ALL: ['SA10', 'M10', 'MS8', 'SPA1'],
    SHOW_CONTRACT:['SPA1']
    // MARKETING_ALL :["","",""],
  };
  export const SIDEBAR = {
    DASHBORD_MENU: ['SA11', 'M11', 'MS1', 'SV1', 'CS1', 'SPA1', 'SPET1' ,'SPET2','L1'],
    USER_MGMT_MENU: ['SA1', 'M2', 'SPA1'],
    VENDOR_MENU: ['SA2', 'M2', 'MS1', 'A1', 'SV3', 'CS4'],
    DRIVER_MENU: ['SA1', 'M2', 'SPA1'],
    CUSTOMER_MENU: ['SA3', 'M3', 'MS3', 'SV4', 'CS7'],
    BOOKING_MENU: ['SA6', 'M6', 'MS6', 'A2', 'SV5', 'CS8', 'SPA1' ,'SPET2','L1'],
    REVENUE_MENU: ['SA7', 'M7', 'A3', 'SPA1'],
    PARKING_SPACE_MENU: ['SA5', 'M5', 'MS5', 'SPA1'],
    PARKING_TYPE_MENU: ['SA10', 'M10', 'MS9'],
    CITY_MENU: ['SA8', 'M8', 'MS7', 'A4'],
    OFFER_MENU: ['SA9', 'M9', 'MS8'],
    BLOG_MENU: ['SA4', 'M4', 'MS4'],
    NOTE_MENU: ['SA4', 'M4', 'MS4'],
    ACCOUNT_DETAIL_MENU:['SPA1','L1'],
    REPORTS_MENU:['SA11', 'M11', 'MS1', 'SV1', 'CS1', 'SPA1'],
    SCAN_QR_MENU: ['SPET1','SPET2' ,'SPA1'],
    Service_TYPE_MENU:['SA6', 'M6', 'MS6', 'A2', 'SV5', 'CS8', 'SPA1' ,'SPET2']
  };
  
